import './BillingPlanCard.css';
import './BillingChoices.css';
export function BillingSkeleton() {
  return <div role="status" aria-label="Loading billing information" aria-busy="true">
    <div className="card-sm mb-6" aria-hidden="true">
      <div className="h-4 w-24 rounded skeleton-shimmer mb-3" />
      <div className="flex items-end gap-2">
        <div className="h-8 w-24 rounded skeleton-shimmer" />
        <div className="h-5 w-14 rounded-full skeleton-shimmer" />
      </div>
      <div className="h-9 w-48 max-w-full rounded-md skeleton-shimmer mt-4" />
      <div className="billing-seat-manager">
        <div className="billing-seat-manager__header">
          <div><div className="h-5 w-12 rounded skeleton-shimmer" /><div className="h-5 w-20 rounded skeleton-shimmer mt-1" /></div>
          <div className="h-9 w-24 rounded-md skeleton-shimmer" />
        </div>
        <div className="h-4 w-52 max-w-full rounded skeleton-shimmer mt-2" />
      </div>
      <div className="billing-account-footer">
        <div><div className="h-5 w-12 rounded skeleton-shimmer" /><div className="h-5 w-24 rounded skeleton-shimmer mt-1" /></div>
        <div className="h-9 w-28 rounded-md skeleton-shimmer" />
      </div>
    </div>
  </div>;
}

export function BillingPlansSkeleton() {
  return <div className="billing-choice-surface" role="status" aria-label="Loading plans" aria-busy="true">
    <div className="billing-choice-grid" aria-hidden="true">
      {[0, 1, 2].map(index => <div key={index} className="card-sm">
        <div className="skeleton-heading w-24" />
        <div className="skeleton-shimmer h-10 w-28 rounded mt-6" />
        <div className="skeleton-line w-full mt-6" />
        <div className="skeleton-shimmer h-10 w-full rounded mt-4" />
        <div className="space-y-3 mt-6"><div className="skeleton-line w-full" /><div className="skeleton-line w-5/6" /><div className="skeleton-line w-2/3" /></div>
      </div>)}
    </div>
  </div>;
}
